//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data() {
      return {
        show: false,
      };
  },
  
  props: {
    title: {
    },
    content: {
    },
    email: {
    },
    phone: {
    },
    linkedIn: {
    },
  },
  
  computed: {

  },
  
  watch: {

  },
  
  methods: {

  },
  
  components: {

  },
  
  created() {
    
  },
  mounted() {

  },
};




// WEBPACK FOOTER //
// ./scripts/vue/InternalBanner.vue